var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"Lfloat",staticClass:"Lfloat"},[_c('h2',[_vm._v(_vm._s(_vm.floatList.title))]),_c('div',{},_vm._l((_vm.floatList.list),function(item,index){return _c('p',{key:index,staticClass:"Lfloat-list",on:{"click":function($event){return _vm.goProject(item.url)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }